// material-ui
import React, {useEffect , useCallback, useState} from "react";
import { styled } from '@mui/material/styles';
import { Button, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import SignatorySubscriptionModal from '../../components/Modals/SignatorySubscriptionModal/SignatorySubscriptionModal'

// styles
const CardStyle = styled(Card)(({ theme }) => ({
  background: 'white',
  opacity: '90%',
  marginTop: '16px',
  marginBottom: '16px',
  overflow: 'hidden',
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    width: '200px',
    height: '200px',
    border: '19px solid ',
    borderColor: '#434249',
    borderRadius: '50%',
    top: '65px',
    right: '-150px'
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    width: '200px',
    height: '200px',
    border: '3px solid ',
    borderColor: '#434249',
    borderRadius: '50%',
    top: '145px',
    right: '-70px'
  }
}));


// ==============================|| PROFILE MENU - UPGRADE PLAN CARD ||============================== //

export const SignatorySubscribe  =  (props) =>{

  const { token, userid } = props;
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('Account Key');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (newValue) => {
    setOpen(false);

    if (newValue) {
      setValue(newValue);
    }
  };

  return(
  <CardStyle>
    <CardContent>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Typography variant="h4">Become and/or Connect with Signatories!</Typography>
        </Grid>
        <Grid item>
          <Typography variant="subtitle2" color="grey.900" sx={{ opacity: 0.6 }}>
            Activate your signatory access, and start tracking your progress! <br />
            
          </Typography>
        </Grid>
        <Grid item>
          <Stack direction="row">
 
              <Button 
                variant="contained"  
                onClick={handleClickOpen}
                sx={{ 
                  boxShadow: 'none',
                  backgroundColor: 'var(--main-color)'
                  
                  }} 
                
                >
                Track & report progress here !
              </Button>  
              <SignatorySubscriptionModal 
                  
                keepMounted
                open={open}
                onClose={handleClose}
                value={value}
                token={token}
                userid ={userid} 
              />
          </Stack>
        </Grid>
      </Grid>
    </CardContent>
  </CardStyle>
  )
  };

export default SignatorySubscribe ;